import {
    handleFrameDrop,
    draw,
    appendStickerToCanvas, lastClickedPlaceholder
} from './drawFunctions.js';

import {
    // Other imports...
    productConfigurations
} from './config.js';

import {
    cardState,SKU,handleSVGActions,initialState
} from './script.js';

import {
    
    hideOverlay,moveCarousel,debouncedMoveCarousel, showItemOverlay
    
} from './controls.js';

import {
    adjustFadeVisibility,updateArrowVisibility,

    onWindowResize,
    revertAction,
    resetCard,
    saveCard,
    open3DPreview,captureSVGtoImages,processProduct
} from './utils.js';

import {
    
    generateContentUniversal
    
} from './ai.js';
import interact from 'interactjs';
import { SVG } from '@svgdotjs/svg.js';

let is3DRenderingActive = false; 
let startX, endX;
let currentOverlay = null; //repeatied in controls, may rethink


let validPages = [];

function updateValidPages() {
    const currentSKU = getSKU(); // Assuming getSKU() gets the current SKU
    validPages = productConfigurations[currentSKU] ? Object.keys(productConfigurations[currentSKU]) : [];
}

export function setupDraggable(selector,type) {
    let clonedElement;
    let offsetX, offsetY;
    let isSwiping = false;
    let initialX = null;
    let initialY = null;
    let rect = null;

    const editorContainer = document.querySelector('.editor-container');

    function enableScroll() {
        editorContainer.style.overflowX = 'auto';
        editorContainer.style.touchAction = 'pan-x'; // Allow horizontal scrolling
    }
    
    function disableScroll() {
        editorContainer.style.overflowX = 'hidden';
        editorContainer.style.touchAction = 'none'; // Disable all touch actions
    }
    

    interact(selector).draggable({
        listeners: {
            start(event) {
                initialX = event.clientX;
                initialY = event.clientY;
                rect = event.target.getBoundingClientRect();
                offsetX = initialX - rect.left;
                offsetY = initialY - rect.top;
              //  enableScroll();  // At the start, we aren't sure of the user's intent yet
            },
            move(event) {
                const dx = event.clientX - initialX;
                const dy = event.clientY - initialY;

                if (Math.abs(dy) > Math.abs(dx)) { // Vertical drag
                    isSwiping = false;
                    disableScroll();

                    // Logic for sticker drag
                    if (!clonedElement) {
                        clonedElement = event.target.cloneNode(true);
                        document.body.appendChild(clonedElement);
                        clonedElement.classList.add('dragging');

                        clonedElement.style.position = 'fixed';
                        clonedElement.style.top = `${event.clientY - offsetY}px`;
                        clonedElement.style.left = `${event.clientX - offsetX}px`;
                        clonedElement.style.width = `${rect.width}px`;
                        clonedElement.style.height = `${rect.height}px`;
                        clonedElement.style.pointerEvents = 'none';
                        clonedElement.style.zIndex = '9999';
                    } else {
                        clonedElement.style.top = `${event.clientY - offsetY}px`;
                        clonedElement.style.left = `${event.clientX - offsetX}px`;
                    }
                } else { // Horizontal swipe
                    isSwiping = true;
                    enableScroll();
                }
            },
            end(event) {
                enableScroll();

                if (!isSwiping && clonedElement) {
                    const dropArea = draw[currentPage].node.getBoundingClientRect();
                    if (event.clientX > dropArea.left && event.clientX < dropArea.right && 
                        event.clientY > dropArea.top && event.clientY < dropArea.bottom) {
                        const itemUrl = event.target.getAttribute('data-url');
                        if (type === 'sticker') {
                            appendStickerToCanvas(itemUrl, event.clientX - dropArea.left, event.clientY - dropArea.top);
                        } else if (type === 'frame') {
                            handleFrameDrop(itemUrl);
                        }
                    }
                    if (clonedElement) {
                        const dropArea = draw[currentPage].node.getBoundingClientRect();
                        if (event.clientX >= dropArea.left && event.clientX <= dropArea.right && 
                            event.clientY >= dropArea.top && event.clientY <= dropArea.bottom) {
                            // Logic to handle the dropped sticker
                        }
                        clonedElement.remove();
                    }
                }
            }
        }
    });
}

export function makeDraggable(sticker) {
    console.log("makeDraggable called", sticker);
    let wasDragged = false;

    // Ensure the sticker is on an SVG
    if (sticker.parent().type !== 'svg') {
        console.error("The sticker is not placed on an SVG.");
        return;
    }
    
    let touchStartTime, touchStartX;

    sticker.node.addEventListener('touchstart', function (e) {
        e.stopPropagation();
        e.preventDefault(); // Prevent default touch behavior
        touchStartTime = new Date().getTime();
        touchStartX = e.touches[0].clientX;

        // Reset the wasDragged flag
        wasDragged = false;

        // Increase z-index of the SVG element and set pointer events to none for the carousel
        e.target.style.zIndex = '1000';
        let carouselItems = document.querySelectorAll('.carousel-item-class');
        carouselItems.forEach(item => item.style.pointerEvents = 'none');
    },  false);

    sticker.node.addEventListener('touchend', function (e) {
        e.stopPropagation();
        let touchEndTime = new Date().getTime();
        let touchEndX = e.changedTouches[0].clientX;

        // Reset z-index and pointer events
        e.target.style.zIndex = '';
        let carouselItems = document.querySelectorAll('.carousel-item-class');
        carouselItems.forEach(item => item.style.pointerEvents = '');

        let timeDifference = touchEndTime - touchStartTime;
        let distanceMoved = Math.abs(touchEndX - touchStartX);

        if (timeDifference < 200 && distanceMoved < 10 && !wasDragged) {
            showItemOverlay(sticker, 'sticker'); // Show overlay if it's a click
        }
    }, false);

    interact(sticker.node)
        .draggable({
            origin: 'parent',
            inertia: true,
            listeners: {
                start(event) {
                    const target = event.target;
                    event.target.style.pointerEvents = 'auto';
                    event.target.style.opacity = '0.5';  // Make the sticker half transparent when dragging starts
                },
                move(event) {
                    wasDragged = true; // Set the flag if movement is detected
                    const target = event.target;
                    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
                    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

                    target.style.transform = `translate(${x}px, ${y}px)`;
                    target.setAttribute('data-x', x);
                    target.setAttribute('data-y', y);
                },
                end(event) {
                    event.target.style.opacity = '1';
                    const target = event.target;
                    const x = parseFloat(target.getAttribute('data-x')) || 0;
                    const y = parseFloat(target.getAttribute('data-y')) || 0;
                    
                    const stickerId = target.getAttribute('data-item-id');
    
                    if (!initialState.cardState[SKU] || !initialState.cardState[SKU][currentPage]) {
                        console.error(`State not defined for SKU: ${SKU} and currentPage: ${currentPage}`);
                        return;
                    }
                    // Prepare the actionData for handleSVGActions
                    let actionData = {
                        stickers: [...initialState.cardState[SKU][currentPage].stickers]
                    };
    
                    // Find the sticker in the existing state
                    const stickerIndex = actionData.stickers.findIndex(s => s.id === stickerId);
                    
                    if (stickerIndex >= 0) {
                        // Update position of the existing sticker
                        actionData.stickers[stickerIndex].x = x;
                        actionData.stickers[stickerIndex].y = y;
                    } else {
                        // Add new sticker to the state
                        actionData.stickers.push({
                            id: stickerId,
                            x: x,
                            y: y
                        });
                    }
    console.log(actionData);
                    // Call handleSVGActions with UPDATE_PROPERTY action
                    handleSVGActions('UPDATE_PROPERTY', actionData, SKU, currentPage);
                    event.target.style.opacity = '1';
                    // Resetting flags
                    wasDragged = false;
                    target.style.pointerEvents = 'bounding-box';
                }
            }
        })
        .on('dragmove', function (event) {
              wasDragged = true;
            event.preventDefault();
        });
}

async function handlePhotoUpload() {
    const input = document.getElementById('photoInput');
    console.log("Reading file: ", input.files[0]);

    if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = async function (e) {
            console.log(lastClickedPlaceholder);

            if (lastClickedPlaceholder) {
                // Create an overlay with "Processing" text
            // Right before starting the upload process
const svgElement = SVG('#front_cover-svg'); // Adjust this line if necessary to correctly select your SVG
const processingOverlay = createProcessingOverlay(svgElement);

// After the upload process finishes (in both try and catch blocks)



                const photoId = lastClickedPlaceholder.attr('data-item-id');
                const imageTransformation = lastClickedPlaceholder.attr('data-image-transformation');
                const textElementId = `user-photo-text-${photoId}`;
                const textElement = document.getElementById(textElementId);

               
                lastClickedPlaceholder.load(e.target.result);
                lastClickedPlaceholder.node.setAttribute('preserveAspectRatio', 'xMidYMid slice');

                if (textElement) {
                    textElement.parentNode.removeChild(textElement);
                   
                }
                const bbox = lastClickedPlaceholder.bbox();
                lastClickedPlaceholder.attr({
                    x: bbox.x,
                    y: bbox.y,
                    width: bbox.width,
                    height: bbox.height
                });

                if (lastClickedPlaceholder) {
                    // Ensure any existing blur filter is removed right at the start
                    lastClickedPlaceholder.node.removeAttribute('filter');

                }
                if (imageTransformation) {
                    try {
                        const file = input.files[0];
                        const uniqueId = new Date().getTime().toString();

                        const formData = new FormData();
                        formData.append('image', file);
                        formData.append('id', uniqueId);

                        const response = await fetch('http://i.expresscreations.co.uk/generate/upload-image', {
                            method: 'POST',
                            body: formData
                        });

                        if (response.ok) {
                            const json = await response.json();
                            console.log("Server Response:", json);

                            const fallbackId = 'unknown';
                            const idToPass = photoId || fallbackId;

                            console.log("photoId before calling generateContent:", idToPass);
                            generateContentUniversal(imageTransformation, 0, json.fileUrl, idToPass);
                        } else {
                            console.error("Failed to upload image");
                        }
                    } catch (error) {
                        console.error(`An error occurred: ${error}`);
                    }  finally {
                        // Remove the "Processing" overlay regardless of the outcome
                        removeProcessingOverlay(processingOverlay);
                    }
                } else {
                    lastClickedPlaceholder.load(e.target.result);
                    lastClickedPlaceholder.node.removeAttribute('data-placeholder');

                    const photoId = lastClickedPlaceholder.attr('data-photo-id');
                    const currentPagePhotos = cardState[SKU][currentPage].user_photo || [];
                    const existingPhotoIndex = currentPagePhotos.findIndex(photo => photo.id === photoId);

                    if (existingPhotoIndex !== -1) {
                        currentPagePhotos[existingPhotoIndex].url = e.target.result;
                    } else {
                        currentPagePhotos.push({
                            id: photoId,
                            url: e.target.result
                        });
                    }

                    cardState[SKU][currentPage].user_photo = currentPagePhotos;
                    // Remove the "Processing" overlay
                    removeProcessingOverlay(processingOverlay);
                }
            }
        };
        reader.readAsDataURL(input.files[0]);
    }
}
function createProcessingOverlay(svgElement) {
    if (!svgElement) {
        console.error('SVG element not found.');
        return;
    }

    // Assuming svgElement is correctly referencing your SVG container
    const width = svgElement.width();
    const height = svgElement.height();

    // Create a group for the overlay
    const overlayGroup = svgElement.group().id('processingOverlay');

    // Add a semi-transparent rectangle to cover the entire SVG
    overlayGroup.rect(width, height).fill('#000').opacity(0.5);

    // Add text on top of the rectangle.
    overlayGroup.text('Processing...')
        .font({ size: 24, fill: '#fff' })
        .center(width / 2, height / 2);

        return overlayGroup; 
}
function removeProcessingOverlay(processingOverlay) {
    if (processingOverlay) {
        processingOverlay.remove();
    } else {
        console.error('Overlay not yet found.');
    }
}
export function setupEventListeners() {
 
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.overlay-control-bar')) {
            hideOverlay();
        }
    });

    const leftArrow = document.getElementById('leftArrow');
    if (leftArrow) {
        leftArrow.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            moveCarousel('prev', 1);
        });
    }

    const rightArrow = document.getElementById('rightArrow');
    if (rightArrow) {
        rightArrow.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            moveCarousel('next', 1);
        });
    }

    const photoInput = document.getElementById('photoInput');
    if (photoInput) {
        photoInput.addEventListener('change', handlePhotoUpload);
    }

    const clearCanvas = document.getElementById('clear-canvas');
    if (clearCanvas) {
        clearCanvas.addEventListener('click', resetCard);
    }

    const preview3D = document.getElementById('preview3D');
    if (preview3D) {
        preview3D.addEventListener('click', open3DPreview);
    }

    document.body.addEventListener('click', function (event) {
        if (currentOverlay && !currentOverlay.contains(event.target)) {
            hideOverlay();
        }
    });

    const devButton = document.querySelector(".dev-button");
    if (devButton) {
        devButton.addEventListener("click", function () {
            const contentContainer = document.getElementById("dev-content-container");
            if (contentContainer.style.display === "none") {
                contentContainer.style.display = "block";
            } else {
                contentContainer.style.display = "none";
            }
        });
    }

    let startX, endX;
    let is3DRenderingActive = false; 
    const canvas3DElement = document.getElementById('threeJSContainer');
    document.addEventListener('3dRenderingStatus', function(e) {
        is3DRenderingActive = e.detail.status;
    });

    const canvasWrapper = document.getElementById('canvas-wrapper');
    if (canvasWrapper) {
        canvasWrapper.addEventListener('touchstart', function (e) {
            if (is3DRenderingActive === true && canvas3DElement && canvas3DElement.contains(e.target)) {
                e.preventDefault();
                return;
            }
            startX = e.touches[0].clientX;
        }, { passive: false });

        canvasWrapper.addEventListener('touchend', function (e) {
            if (is3DRenderingActive === true) {
                return;
            }
            endX = e.changedTouches[0].clientX;
            const swipeDistance = Math.abs(startX - endX);

            if (swipeDistance > 60) {
                const direction = startX < endX ? 'prev' : 'next';
                let targetPageIndex = calculateTargetPageIndex(direction);
                moveCarousel(direction, 1, false);

                setTimeout(() => {
                    if (!validPages || targetPageIndex === undefined) return;
                    const canvasContainer = document.getElementById('canvas-container');
                    const targetContainerId = validPages[targetPageIndex] + '-container';
                    const targetContainer = document.getElementById(targetContainerId);

                    if (targetContainer) {
                        const containerCenterX = targetContainer.offsetLeft + targetContainer.offsetWidth / 2;
                        const containerScrollPosition = containerCenterX - canvasContainer.offsetWidth / 2;
                        canvasContainer.scrollTo({
                            left: containerScrollPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 50);
            }
        }, false);
    }
}
function calculateTargetPageIndex(direction) {
    // Ensure validPages is not undefined
    if (!validPages) {
        updateValidPages(); // Update or handle the error appropriately
    }

    const currentIndex = validPages.indexOf(currentPage);
    let delta = direction === 'next' ? 1 : -1;
    return Math.max(0, Math.min(currentIndex + delta, validPages.length - 1));
}


export function attachItemListeners(item, itemConfig, type, product_data) {


    
    if (!initialState.cardState[product_data] || !initialState.cardState[product_data][type]) {
        console.error(`State not defined for SKU: ${product_data} and type: ${type}`);
        return;
    }
    let wasDragged = false;  // Flag to track if the item was dragged

    // Handle the end of a drag event
  //  item.on('dragend', function(event) {
    //    wasDragged = true;  // Set to true when drag ends
        // Reapply the draggable functionality to ensure it remains draggable
     //   makeDraggable(item);
  //  });

    // Handle the click event
    item.node.addEventListener('click', function (event) {
        if (type === 'sticker' && !wasDragged) { 
            // Only show overlay for a sticker if it was not dragged
            showItemOverlay(item, 'sticker');
        } else if (type === 'user_photo' && item.node.getAttribute('data-placeholder') === 'true') {
       
            // Handle placeholder photo logic
            lastClickedPlaceholder = item;
            document.getElementById('photoInput').click();
        } else if (type === 'user_photo') {
    
            // Handle existing photo logic
           // showItemOverlay(item, 'photo');
            //updateCardStateWithItemProperties(item, type);
        }
        else { }
        wasDragged = false;  // Reset the flag after handling click
    });
}

